<template>
  <div v-if="isInHolidayPeriod" class="wallet-holiday-notice-wrapper">
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 21L12 2L23 21H1ZM12 18C12.2833 18 12.5208 17.9042 12.7125 17.7125C12.9042 17.5208 13 17.2833 13 17C13 16.7167 12.9042 16.4792 12.7125 16.2875C12.5208 16.0958 12.2833 16 12 16C11.7167 16 11.4792 16.0958 11.2875 16.2875C11.0958 16.4792 11 16.7167 11 17C11 17.2833 11.0958 17.5208 11.2875 17.7125C11.4792 17.9042 11.7167 18 12 18ZM11 15H13V10H11V15Z"
        fill="#FFAA00"
      />
    </svg>

    <div class="wallet-holiday-notice-content">
      <h2>Aviso importante sobre os feriados</h2>

      <p>
        Devido ao feriado de Finados, as transferências estarão indisponíveis, excepcionalmente, no dia <strong>2 de novembro</strong>. Nos demais dias, funcionarão normalmente.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visibleRanges: {
      type: Array,
      required: true,
      validator: (ranges) => {
        return ranges.every(
          (range) =>
            range.start instanceof Date &&
            range.end instanceof Date &&
            range.start <= range.end
        )
      },
    },
  },
  data() {
    return {
      isInHolidayPeriod: false,
    }
  },
  created() {
    const today = new Date()

    this.isInHolidayPeriod = this.visibleRanges.some(
      ({ start, end }) => today >= start && today <= end
    )
  },
}
</script>

<style lang="scss">
.wallet-holiday-notice-wrapper {
  background-color: #fff5cc;
  border: 1px solid #ffaa00;
  padding: 16px 12px;
  border-radius: 8px;

  display: flex;
  align-items: start;
  gap: 12px;

  margin: 24px 2em 44px 2.5em;

  & > svg {
    min-width: 25px !important;
  }

  .wallet-holiday-notice-content {
    h2 {
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 8px;
      color: $gray-7;
    }

    p {
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: $neutral !important;
      letter-spacing: 0.3px;

      strong {
        font-weight: 700;
        color: $neutral;
      }
    }
  }

  @media screen and (max-width: 1408px) {
    margin-left: 1em;
  }

  @media screen and (max-width: 1215px) {
    margin-left: 0.3em;
  }

  @media screen and (max-width: 768px) {
    margin: 24px auto 16px;
    width: 100%;
    max-width: 360px;

    .wallet-holiday-notice-content {
      p {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }

  @media screen and (max-width: 405px) {
    width: auto;
    margin-inline: 16px;
  }
}
</style>
